export const getCompanyURL = id => `/company/profile/${id}`;
